



















import { Component, Vue } from 'vue-property-decorator';
import { WxDrawer, WxFooter, WxHeader, WxConfirm } from 'wax-lib';

@Component({
    components: {
        itkDrawer: WxDrawer,
        itkHeader: WxHeader,
        itkErrorModal: WxConfirm,
        itkFooter: WxFooter,
    },
})
export default class App extends Vue {
    private drawer = true;

    private created() {
        window.addEventListener('beforeunload', this.hndlBeforeunload);
    }

    private get allowedRoutes() {
        return this.$router.allowedRoutes();
    }

    private hndlBeforeunload(e: Event) {
        // TODO: this is verry restrictive, better save timestamp and allow relogin within 5 min.
        // TODO: findout how to catch/prevent browser tab close like regex101.com
        this.$store.commit('unloadApp');
    }
}
